<template>
  <div>
    <img :src="baseOSSUrl + '/banner1.png'" class="w-full bgImg" alt="">
  </div>
</template>

<script>
import {
baseOSSUrl
} from '@/utils/oss'
export default {
  name: "imgView",
  data() {
    return {
      baseOSSUrl
    }
  }
}
</script>

<style scoped>
.bgImg{
  height: 16.25rem;
}
</style>